import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { InvoiceCloudPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/invoicecloud/invoicecloud-payment-processor-account-configuration';

@Component({
  selector: 'wm-payment-account-config-invoicecloud',
  templateUrl: './payment-account-config-invoicecloud.component.html',
  standalone: false
})
export class PaymentAccountConfigInvoiceCloudComponent extends PaymentAccountConfigBaseComponent implements OnInit {
  @Input() config: InvoiceCloudPaymentProcessorAccountConfiguration;

  constructor(fb: UntypedFormBuilder) {
    super(fb);
    this.showUsername = false;
    this.showPassword = false;
  }

  ngOnInit() {
    if (!this.config) {
      this.config = new InvoiceCloudPaymentProcessorAccountConfiguration();
    }

    
    this.addValidation('invoiceTypeId', Validators.required, this.config.invoiceTypeId);
    this.addValidation('billerGuid', Validators.required, this.config.billerGuid);

    this.form.valueChanges.subscribe(values => {
      Object.assign(this.config, values);
    });
  }
}